export default "__VITE_ASSET__ZNrhgr4M__"